/* eslint-disable */
import {
  Box,
  Button,
  FormControl,
  Grid,
  IconButton,
  InputLabel,
  MenuItem,
  Paper,
  Select,
  TextField,
  Tooltip,
  Typography,
  Autocomplete,
} from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import { DatePicker } from "@mui/x-date-pickers";
import RemoveRedEyeOutlinedIcon from "@mui/icons-material/RemoveRedEyeOutlined";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import RemoveCircleOutlineOutlinedIcon from "@mui/icons-material/RemoveCircleOutlineOutlined";
import SearchIcon from "@mui/icons-material/Search";
import CleaningServicesIcon from "@mui/icons-material/CleaningServices";
import { Add } from "@mui/icons-material";
import { useEffect, useState, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { getCacheData } from "../../services/CacheService";
import { getEnvios } from "../../../project/services/EnvioArticuloService";
import Message from "../../../project/utils/Message";
import WaitingDialog from "../../utils/WaitingDialog";
import AuthContext from "../../contexts/AuthContext";

const initialSearchData = {
  codigo: "",
  idAreaDestino: "",
  fechaCreacionDesde: null,
  fechaCreacionHasta: null,
  estadoActual: "todo",
  usuario: "",
};

const estadoOptions = [
  {
    id: "todo",
    descripcion: "Todo",
  },
  {
    id: "pendiente-recibir",
    descripcion: "Pendiente de recibir",
  },
  {
    id: "recibido",
    descripcion: "Recibido",
  },
  {
    id: "anulado",
    descripcion: "Anulado",
  },
];

const nameItemsText = "Envío de Artículos";
//
// #############################################################################
//
const EnvioArticuloTable = () => {
  const navigate = useNavigate();
  const [searchData, setSearchData] = useState(initialSearchData);
  const [isDoingSomething, setIsDoingSomething] = useState(false);
  const [envios, setEnvios] = useState([]);
  const [message, setMessage] = useState({});
  const [showMessage, setShowMessage] = useState(false);
  const [totalRowsCount, setTotalRowsCount] = useState(0);
  const [currentPage, setCurrentPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [usuarios, setUsuarios] = useState([]);
  const [areas, setAreas] = useState([]);
  const [valueACAreaDestino, setValueACAreaDestino] = useState({
    id: "",
    descripcion: "",
  });
  const [inputValueACAreaDestino, setInputValueACAreaDestino] = useState("");

  const { hasPermission } = useContext(AuthContext);
  const _crearEnvioArticulo = hasPermission("envio-articulo-c");
  const _editarEnvioArticulo = hasPermission("envio-articulo-e");
  const _anularEnvioArticulo = hasPermission("envio-articulo-a");

  const tableColumns = [
    {
      field: "codigo",
      headerName: "Código",
      headerAlign: "center",
      align: "center",
      flex: 1,
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.codigo;
        _val = _val ? _val.toUpperCase() : "";
        return _val;
      },
    },
    {
      field: "descripcion_area_destino",
      headerName: "Área de destino",
      headerAlign: "center",
      align: "left",
      flex: 3,
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.descripcion_area_destino;
        _val = _val ? _val.toUpperCase() : "";
        return _val;
      },
    },
    {
      field: "fecha_creacion",
      headerName: "Fecha de creación",
      headerAlign: "center",
      align: "center",
      flex: 1,
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.fecha_creacion;
        _val = _val ? _val : "";
        return _val;
      },
    },
    {
      field: "estado",
      headerName: "Estado actual",
      headerAlign: "center",
      align: "center",
      flex: 1,
      sortable: false,
      renderCell: (params) => {
        let _val = "ERR";
        switch (params.row.estado) {
          case "pendiente-recibir":
            _val = "PENDIENTE DE RECIBIR";
            break;
          case "recibido":
            _val = "RECIBIDO";
            break;
          case "anulado":
            _val = "ANULADO";
            break;
          default:
            _val = "ERROR";
        }
        return _val;
      },
    },
    {
      field: "fecha_estado",
      headerName: "Fecha de Estado",
      headerAlign: "center",
      align: "center",
      flex: 1,
      sortable: false,
      renderCell: (params) => {
        return params.row.fecha_estado;
      },
    },
    {
      field: "usuario",
      headerName: "Operador",
      headerAlign: "center",
      align: "center",
      flex: 1,
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.usuario;
        _val = _val ? _val.toLowerCase() : "";
        return _val;
      },
    },
    {
      field: "actions",
      headerName: "Acciones",
      headerAlign: "center",
      align: "left",
      flex: 1,
      sortable: false,
      filterable: false,
      renderCell: (params) => (
        <>
          <Tooltip title="ver envio">
            <IconButton
              size="small"
              aria-label="update"
              onClick={() => obtieneEnvio(params.row, "view")}
            >
              <RemoveRedEyeOutlinedIcon />
            </IconButton>
          </Tooltip>

          {params.row.estado === "pendiente-recibir" && _editarEnvioArticulo && (
            <Tooltip title="editar envio">
              <IconButton
                size="small"
                aria-label="update"
                onClick={() => editaEnvio(params.row, "update")}
              >
                <EditOutlinedIcon />
              </IconButton>
            </Tooltip>
          )}

          {params.row.estado === "pendiente-recibir" && _anularEnvioArticulo && (
            <Tooltip title="anular envio">
              <IconButton
                size="small"
                aria-label="update"
                onClick={() => editaEnvio(params.row, "delete")}
              >
                <RemoveCircleOutlineOutlinedIcon />
              </IconButton>
            </Tooltip>
          )}
        </>
      ),
    },
  ];

  const handlePaginationModelChange = (newModel) => {
    setCurrentPage(newModel.page);
    setRowsPerPage(newModel.pageSize);
  };

  const tableOptions = {
    paginationMode: "server",
    rowCount: totalRowsCount,
    paginationModel: {
      page: currentPage,
      pageSize: rowsPerPage,
    },
    onPaginationModelChange: handlePaginationModelChange,
    pageSizeOptions: [10, 20, 30],
    disableRowSelectionOnClick: true,
    disableColumnMenu: true,
    disableColumnFilter: true,
    disableColumnSelector: true,
    disableDensitySelector: true,
    localeText: {
      noRowsLabel: "",
      noResultsOverlayLabel: "",
      MuiTablePagination: {
        labelRowsPerPage: "Filas:",
        labelDisplayedRows: ({ from, to, count }) =>
          `${from}-${to} de ${count !== -1 ? count : `más de ${to}`}`,
      },
    },
    sx: {
      "& .MuiDataGrid-cell": {
        fontSize: "0.9em",
      },
      "& .MuiDataGrid-columnHeaders": {
        backgroundColor: "#f5f5f5",
      },
    },
  };
  //
  // ################################################################################
  //
  useEffect(() => {
    loadUsuarios();
    loadAreas();
  }, []);
  //
  // ################################################################################
  //
  useEffect(() => {
    load();
  }, [currentPage, rowsPerPage]);
  //
  // ##########################################################################
  //
  const loadUsuarios = async () => {
    const response = await getCacheData("usuario");
    if (response.ok) {
      setUsuarios(response.data.data);
    } else {
      setMessage({
        messageText: response.messageText,
        severity: response.messageSeverity,
      });
      setShowMessage(true);
    }
  };
  //
  // ################################################################################
  //
  const loadAreas = async () => {
    const response = await getCacheData("area");
    if (response.ok) {
      const _response = response.data.data.filter(area => area.interno_externo === "interno" && area.id !== localStorage.getItem("id_area_ventas"));
      let _areas = [];
      _response.forEach((item) => {
        _areas.push({
          id: item.id,
          label: item.descripcion,
        });
      });
      setAreas(_areas);
    } else {
      setAreas([]);
      setMessage({
        messageText: response.messageText,
        severity: response.messageSeverity,
      });
      setShowMessage(true);
    }
  };
  //
  // ################################################################################
  // 
  const load = async () => {

    let _params = {
      idAreaDestino: searchData.idAreaDestino,
      usuario: searchData.usuario,
      fechaCreacionDesde: searchData.fechaCreacionDesde,
      fechaCreacionHasta: searchData.fechaCreacionHasta,
      estadoActual: searchData.estadoActual,
      codigo: searchData.codigo,
      rows: rowsPerPage,
      first: currentPage * rowsPerPage,
    };

    setIsDoingSomething(true);
    const response = await getEnvios(_params);
    setIsDoingSomething(false);

    if (response.ok) {
      setTotalRowsCount(response.data.count);
      setEnvios(response.data.data);
    } else {
      setEnvios([]);
      setMessage({
        messageText: response.messageText,
        severity: response.messageSeverity,
      });
      setShowMessage(true);
    }
  };
  //
  // ################################################################################
  //
  const handleChange = (e) => {
    setSearchData({
      ...searchData,
      [e.target.name]: e.target.type === "checkbox" ? e.target.checked : e.target.value,
    });
  };
  //
  // ################################################################################
  //
  const handleChangeFechaCreacionDesde = (fecha) => {
    setSearchData({
      ...searchData,
      fechaCreacionDesde: fecha,
    });
  };
  //
  // ################################################################################
  //
  const handleChangeFechaCreacionHasta = (fecha) => {
    setSearchData({
      ...searchData,
      fechaCreacionHasta: fecha,
    });
  };
  //
  // ################################################################################
  //
  const handleLimpiar = () => {
    setCurrentPage(0);
    setTotalRowsCount(0);
    setSearchData(initialSearchData);
    setValueACAreaDestino({ descripcion: "", id: "" });
    setEnvios([]);
  };
  //
  // ################################################################################
  //
  const handleBuscar = () => {
    if (currentPage !== 0) {
      setCurrentPage(0);
    } else {
      load();
    }
  };
  //
  // ###############################################################################
  //
  const obtieneEnvio = (parRow, parAction) => {
    navigate("/envio-articulo/" + parRow.id + "/" + parAction);
  };
  //
  // ################################################################################
  //
  const nuevoEnvio = () => {
    navigate("/envio-articulo/new", { state: { action: "new" } });
  };
  //
  // ################################################################################
  //
  const editaEnvio = (parRow, parAction) => {
    let _aditionalData = {
      codigoEnvio: parRow.codigo,
      estadoEnvio: parRow.estado,
    };
    navigate("/envio-articulo/" + parRow.id + "/" + parAction, { state: _aditionalData });
  };
  //
  // ################################################################################
  // 
  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      handleBuscar();
    }
  };
  //
  // ################################################################################
  //
  return (
    <>
      <Paper elevation={0} sx={{ mx: 0.5, maxWidth: "100%" }}>
        <Paper elevation={1} >
          <Box sx={{ mx: 1, px: 1, pb: 1 }}>
            <Grid container spacing={1}>
              <Grid item xs={12}>
                <Box sx={{ mt: 1 }} display="flex" justifyContent="space-between" alignItems="center">
                  <Typography variant="h5" display="block" gutterBottom >
                    {nameItemsText}
                  </Typography>
                </Box>
              </Grid>

              <Grid item xs={12} md={12} lg={2}>
                <TextField
                  sx={{ width: "100%" }}
                  inputProps={{
                    autoComplete: "off",
                  }}
                  id="codigo"
                  label="Código de envio"
                  variant="outlined"
                  size="small"
                  name="codigo"
                  value={searchData.codigo}
                  onChange={handleChange}
                  onKeyDown={handleKeyDown}
                />
              </Grid>

              <Grid item xs={12} md={12} lg={2}>
                <Autocomplete
                  id="id-area-destino"
                  size="small"
                  value={
                    valueACAreaDestino && valueACAreaDestino.id
                      ? valueACAreaDestino
                      : null
                  }
                  onChange={(event, newValue) => {
                    setValueACAreaDestino(newValue);
                    setSearchData({
                      ...searchData,
                      idAreaDestino: newValue ? newValue.id : "",
                    });
                  }}
                  inputValue={inputValueACAreaDestino}
                  onInputChange={(event, newInputValue) => {
                    setInputValueACAreaDestino(newInputValue);
                  }}
                  options={areas}
                  getOptionLabel={(option) => option.label || ""}
                  renderInput={(params) => <TextField {...params} label="Area de Destino" />}
                  isOptionEqualToValue={(option, value) => {
                    if (!value || !value.id) return false;
                    return option.id === value.id;
                  }}
                  disableClearable={true}
                />
              </Grid>

              <Grid item xs={12} md={12} lg={2}>
                <DatePicker
                  sx={{
                    width: "100%",
                    mb: 1,
                    "& .MuiInputLabel-root": {
                      transform: "translate(14px, 9px) scale(1)",
                    },
                    "& .MuiInputBase-root": {
                      paddingRight: "10px",
                    },
                    "& .MuiInputLabel-shrink": {
                      transform: "translate(14px, -8px) scale(0.75)",
                    },
                  }}
                  id="fechaCreacionDesde"
                  label="Creación Desde Fecha"
                  variant="outlined"
                  size="small"
                  name="fechaCreacionDesde"
                  value={searchData.fechaCreacionDesde}
                  format="dd/MM/yyyy"
                  maxDate={new Date()}
                  onChange={(newValue) =>
                    handleChangeFechaCreacionDesde(newValue)
                  }
                  slots={{ textField: TextField }}
                  slotProps={{
                    textField: {
                      size: "small",
                      sx: { width: "100%" },
                    },
                  }}
                />
              </Grid>

              <Grid item xs={12} md={12} lg={2}>
                <DatePicker
                  sx={{
                    width: "100%",
                    mb: 1,
                    "& .MuiInputLabel-root": {
                      transform: "translate(14px, 9px) scale(1)",
                    },
                    "& .MuiInputBase-root": {
                      paddingRight: "10px",
                    },
                    "& .MuiInputLabel-shrink": {
                      transform: "translate(14px, -8px) scale(0.75)",
                    },
                  }}
                  id="fechaCreacionHasta"
                  label="Creación hasta fecha"
                  variant="outlined"
                  name="fechaCreacionHasta"
                  value={searchData.fechaCreacionHasta}
                  format="dd/MM/yyyy"
                  maxDate={new Date()}
                  onChange={(newValue) =>
                    handleChangeFechaCreacionHasta(newValue)
                  }
                  slots={{ textField: TextField }}
                  slotProps={{
                    textField: {
                      size: "small",
                      sx: { width: "100%" },
                    },
                  }}
                />
              </Grid>

              <Grid item xs={12} md={12} lg={2}>
                <FormControl sx={{ width: "100%" }}>
                  <InputLabel id="estado-actual-select-label">Estado actual</InputLabel>
                  <Select
                    labelId="estado-actual-select-label"
                    id="estado-actual-select"
                    name="estadoActual"
                    value={searchData.estadoActual}
                    label="Estado actual"
                    size="small"
                    onChange={handleChange}
                    MenuProps={{ style: { maxHeight: "300px" } }}
                  >
                    {estadoOptions.map((item) => (
                      <MenuItem key={item.id} value={item.id}>
                        {item.descripcion}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>

              {/* <Grid item xs={12} md={12} lg={2}>
                <FormControl sx={{ width: "100%" }}>
                  <InputLabel
                    id="usuario-select-label"
                    sx={{
                      transform: "translate(15px, 10px) scale(1)",
                      "&.MuiInputLabel-shrink": {
                        transform: "translate(14px, -8px) scale(0.75)", // Ajuste para cuando el label se reduce
                      },
                    }}
                  >
                    Usuario
                  </InputLabel>
                  <Select
                    labelId="usuario-select-label"
                    id="usuario-registracion-select"
                    name="usuario"
                    value={searchData.usuario}
                    label="Usuario de registración"
                    size="small"
                    onChange={handleChange}
                    MenuProps={{ style: { maxHeight: "300px" } }}
                  >
                    {usuarios.map((item) => (
                      <MenuItem key={item.id} value={item.id}>
                        {item.nombre}, {item.apellido}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid> */}
            </Grid>
          </Box>

          <Box sx={{ mx: 1, mb: 1, px: 1, pb: 1 }}>
            <Grid container spacing={1}>

              {_crearEnvioArticulo && (
                <Grid item xs={12} md={12} lg={1}>
                  <Box sx={{ display: "flex", gap: 1 }}>
                    <Tooltip title="crear envío de artículos">
                      <Button
                        fullWidth
                        className="btn-add"
                        variant="contained"
                        size="small"
                        onClick={nuevoEnvio}
                        startIcon={<Add />}
                      >
                        Nuevo
                      </Button>
                    </Tooltip>
                  </Box>
                </Grid>
              )}

              <Grid item xs={12} md={12} lg={1}>
                <Box sx={{ display: "flex", gap: 1 }}>
                  <Tooltip title="buscar">
                    <Button
                      fullWidth
                      variant="contained"
                      size="small"
                      onClick={handleBuscar}
                      startIcon={<SearchIcon />}
                    >
                      Buscar
                    </Button>
                  </Tooltip>
                </Box>
              </Grid>

              <Grid item xs={12} md={12} lg={1}>
                <Box sx={{ display: "flex", gap: 1 }}>
                  <Tooltip title="limpiar">
                    <Button
                      fullWidth
                      variant="outlined"
                      size="small"
                      onClick={handleLimpiar}
                      startIcon={<CleaningServicesIcon />}
                    >
                      Limpiar
                    </Button>
                  </Tooltip>
                </Box>
              </Grid>
            </Grid>
          </Box>
        </Paper>

        <DataGrid
          rows={envios}
          columns={tableColumns}
          {...tableOptions}
        />
      </Paper>

      {showMessage && (
        <Message
          showMessage={showMessage}
          setShowMessage={setShowMessage}
          message={message}
        />
      )}

      <WaitingDialog open={isDoingSomething} />
    </>
  );
};
export default EnvioArticuloTable;
